import { gql, useMutation } from '@apollo/client';

import { GET_MEMBERS } from './get-members.hook';

export const UPDATE_MEMBER_POSITION = gql`
  mutation updateMemberPosition($memberId: ObjectId!, $positionId: ObjectId!) {
    updateMemberPosition(memberId: $memberId, positionId: $positionId) {
      _id
    }
  }
`;

export const useUpdateMemberPosition = ({ onSuccess }: { onSuccess: () => void }) => {
  const [updateMemberPosition] = useMutation(UPDATE_MEMBER_POSITION, {
    refetchQueries: [GET_MEMBERS],
    onCompleted: onSuccess,
  });

  return { updateMemberPosition };
};
